<i18n locale="en">
  {
    "label": "Transparent navigation"
  }
  </i18n>

<template>
  <OwnToggle
    :model-value="transparent"
    :label="t('label')"
    control
    @update:model-value="changeTransparency"
  />
</template>

<script>
import set from 'lodash/set'
import { useI18n } from 'vue-i18n'
import { mapActions, mapGetters } from 'vuex'

import { useApplicationScope } from '@/core/store'
import { OwnToggle } from '@/ui/OwnToggle'

export default {
  name: 'NavigationTransparencyEditor',
  components: {
    OwnToggle,
  },

  setup() {
    const { t } = useI18n()
    const { activeBrandId } = useApplicationScope()

    return { activeBrandId, t }
  },
  computed: {
    ...mapGetters({
      currentResource: 'websiteBuilder/currentResource',
    }),
    transparent() {
      return this.currentResource?.funnel?.navigation?.transparent ?? false
    },
  },
  methods: {
    ...mapActions({
      updateResource: 'websiteBuilder/updateResource',
    }),
    changeTransparency(value) {
      this.updateResource(set({}, 'funnel.navigation.transparent', value))
    },
  },
}
</script>

<style lang="scss" scoped>
/* Styles for NavigationTransparencyEditor component */
</style>
